// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3-7jv","disabled":"FileBtn_disabled__15DLz","warn":"FileBtn_warn__1PIAA","fade":"FileBtn_fade__2_HJK"};